import React from 'react';
import classnames from 'classnames';
import {getBreakLinesTextShumaType3} from "../../../utils/texts";
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';

const Section8Text22 = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {arnonaVoucher} = context.data.pdfData;

  return (
    <div ref={ref}>
      {Boolean(arnonaVoucher) && (
        <div className={classnames(styles.itemText, styles.innerPadding)}>
          <span className={styles.bold}>שובר ארנונה: </span>
          <span>{getBreakLinesTextShumaType3(arnonaVoucher)}</span>
        </div>
      )}
    </div>
  );
});

export default Section8Text22;
